export default __webpack_public_path__ + "static/media/bl.5984f038.svg";